import React, { useEffect, useState } from "react";
import PubSub from "pubsub-js";
import Variations from "./Variations";
// import { WrapperContext } from "../Layout";
import clsx from "clsx";
import { _linkResolver } from "../../core/utils";

const AddToCart = ({ input }) => {
  const {
    // _id,
    slug,
    // seo,
    title,
    description,
    price,
    images,
    productVariations,
  } = input;
  // console.log(productVariations);
  // console.log(input);
  const isSimpleProduct = productVariations.variations.length === 0;
  // console.log("productVariations", productVariations);
  // console.log("productVariations", isSimpleProduct);
  // const { location } = useContext(WrapperContext);
  const [variation, setVariation] = useState([]);
  const [qty, setQty] = useState(1);
  const [variationPrice, setVariationPrice] = useState(price);

  const productDescription = description ? description[0].children[0].text : "";
  const canPurchase = isSimpleProduct || variation.length > 0;

  useEffect(() => {
    const tokenChange = PubSub.subscribe("VARIATION_CHANGE", (evt, data) => {
      // console.log(data);
      if (data.label === "qty") {
        setQty(data.value);
      }
      setVariation((prev) => [...prev, data]);
      const modifiedPrice = data.price ? price + data.price : price;
      setVariationPrice(modifiedPrice);
    });

    const tokenReset = PubSub.subscribe("VARIATION_RESET", (e) => {
      // setVariation(null);
    });
    //
    return () => {
      PubSub.unsubscribe(tokenChange);
      PubSub.unsubscribe(tokenReset);
    };
  }, [price]);

  const _getCustomDataAttr = () => {
    if (!productVariations) return;

    let itemCustomAttr = {};

    productVariations.variations.forEach((el, i) => {
      itemCustomAttr[`data-item-custom${i + 1}-name`] = el.label.toLowerCase();
      itemCustomAttr[`data-item-custom${i + 1}-required`] = true;
      // console.log(el);
      const options = el.options.map((_el) => {
        // const { option, price } = _el;
        const _option = _el.option;
        const _price = _el.price;

        let priceModifier = "";
        // console.log(_price, price);
        if (_price) priceModifier = `[+${_price}]`;
        else priceModifier = ``;
        // else priceModifier = `[+0]`;

        // console.log(basePrice, price);
        return `${_option}${priceModifier}`;
      });

      itemCustomAttr[`data-item-custom${i + 1}-options`] = options
        .toString()
        .split(",")
        .join("|");

      el.options.forEach((_el) => {
        if (_el.grams) {
          itemCustomAttr[`data-item-weight`] = _el.grams;
        }
        if (_el.dimensions) {
          const dimensions = _el.dimensions.split(",");
          itemCustomAttr[`data-item-length`] = dimensions[0];
          itemCustomAttr[`data-item-height`] = dimensions[1];
          itemCustomAttr[`data-item-width`] = dimensions[2];
        }
      });
    });

    if (variation.length) {
      variation.forEach((el, i) => {
        console.log(el);
        itemCustomAttr[`data-item-custom${el.index}-value`] = el.value;
      });
    }

    return itemCustomAttr;
  };

  /*
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Gameboy Color - Green",
    "image": "gameboycolor.jpg",
    "offers": {
      "@type": "Offer",
      "price": "35.00",
      "priceCurrency": "USD",
      "url": "/buy-product/"
    }
  }
</script>
  */
  return (
    <div className='form text-sm'>
      <div className='row '>
        {productVariations &&
          productVariations.variations.map((el, i) => (
            <div className={`col-md-4 col-xs-12`} key={i}>
              <div className='bt bb mb-md'>
                <Variations
                  input={{
                    index: i + 1,
                    label: el.label,
                    variations: el.options,
                  }}
                />
              </div>
            </div>
          ))}
      </div>
      <div className='row '>
        <div className='col-md-4'>
          <div className='bt bb mb-md'>
            <div className='price'>{variationPrice} €</div>
          </div>
        </div>
        <div className='col-md-8'>
          <button
            // ref={ctaRef}
            className={clsx(
              "snipcart-add-item button button-o w-full",
              !canPurchase ? "disabled" : ""
            )}
            data-item-id={slug.current}
            data-item-price={price}
            data-item-url={_linkResolver(input)}
            data-item-description={productDescription}
            data-item-image={images[0].asset.url}
            data-item-name={title}
            data-item-quantity={qty}
            data-item-has-taxes-included='true'
            {..._getCustomDataAttr()}>
            Add to cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToCart;
